import {createContext} from "react";

export const LikesContext = createContext<{likes:number[], setLikes:Function}>({
    likes: [],
    setLikes: () => {}
})